import request from '@/plugins/axios'

//删除超过半年的下载包
export function delHalfPackage() {
  return request({
    url: '/picturePackage/delHalfPackage',
    method: 'get'
  })
}


//获取图片包列表
export function listPicturePackage(params) {
  return request({
    url: '/picturePackage/listPicturePackage',
    method: 'get',
    params
  })
}


//获取图片包列表
export function listDownResourceRank(params) {
  return request({
    url: '/picturePackage/downResourceRank',
    method: 'get',
    params
  })
}

// 下载资源包
export function downPackage(params) {
  return request({
    url: '/picturePackage/downPackage',
    method: 'get',
    params
  })
}


//积分模式下查询图片积分
export function searchPicturePackageInfo(data) {
  return request({
    url: '/picturePackage/downPackageUserPoints',
    method: 'post',
    data
  })
}


//添加图片包
export function addPicturePackage(data) {
  return request({
    url: '/picturePackage/addPicturePackage',
    method: 'post',
    data
  })
}

//删除图片包
export function deletePicturePackage(params) {
  return request({
    url: '/picturePackage/deletePicturePackage/' + params,
    method: 'get'
  })
}

//查询单个图片包
export function getPicturePackage(params) {
  return request({
    url: '/picturePackage/getPicturePackage/' + params,
    method: 'get'
  })
}

//修改图片包信息
export function updatePicturePackage(data) {
  return request({
    url: '/picturePackage/updatePicturePackage',
    method: 'post',
    data
  })
}